import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClientImport } from "@/components/booking/ClientImport";
import { Upload, Users, Scissors, CalendarDays } from "lucide-react";

const ITEMS = [
  { resource: "clients", icon: Users, title: "Clients", body: "Names, phone, email, date of birth, source, marketing opt-in and legacy flag. Existing clients (matched by phone or email) are skipped." },
  { resource: "services", icon: Scissors, title: "Services", body: "Name, category, duration, buffer and price. Categories are created by name; duplicate service names are skipped." },
  { resource: "bookings", icon: CalendarDays, title: "Appointments", body: "Past and future appointments matched to a client, service and staff member by name. Past dates fill client history; future dates land on the calendar." },
];

export default function ImportData() {
  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-8" data-testid="import-page">
      <div className="mb-6">
        <h1 className="font-heading font-extrabold text-3xl tracking-tight flex items-center gap-2"><Upload className="h-7 w-7 text-primary" />Import data</h1>
        <p className="text-muted-foreground mt-1">Moving from another system? Bring your clients, services and appointment history across from a CSV export.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {ITEMS.map((it) => (
          <Card key={it.resource} className="rounded-2xl border p-5 shadow-sm flex flex-col" data-testid={`import-card-${it.resource}`}>
            <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center mb-3"><it.icon className="h-5 w-5 text-primary" /></div>
            <div className="font-heading font-semibold">{it.title}</div>
            <p className="text-sm text-muted-foreground mt-1 flex-1">{it.body}</p>
            <ClientImport resource={it.resource} trigger={<Button variant="outline" className="rounded-lg mt-4 w-full" data-testid={`import-${it.resource}-button`}><Upload className="h-4 w-4 mr-1.5" />Import {it.title.toLowerCase()}</Button>} />
          </Card>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-6">Tip: import clients first, then services, then appointments — so every appointment can be matched to the right client and service.</p>
    </div>
  );
}
